import PaymentModalWithoutStripe from "./paymentModalWithoutStripe";
import { injectStripe } from "react-stripe-elements";

export default injectStripe(PaymentModalWithoutStripe);
